import React from 'react'
import { Loader } from './Loader.styled'

export default ({ children }) => {
  return <Loader>{children}</Loader>
}
